import { connect, mapReadPretty, mapProps } from "@formily/react";
import { ColorField as ColorFieldBase } from "../base/ColorField";
import { ColorSwatch } from "../base/ColorSwatch";
import { isField } from "@formily/core";
import { HStack } from "../../../../styled-system/jsx";

export const ColorField = connect(
  ColorFieldBase,
  mapProps((props, field) => {
    if (!isField(field)) return props;

    return {
      ...props,
      label: field.title,
      errorMessage: field.selfErrors[0],
      isDisabled: field.disabled,
      onChange: (value: string | null) => {
        void field.onInput(value);
      },
    };
  }),
  mapReadPretty((props) => (
    <HStack gap="small" alignItems="center">
      <ColorSwatch size="small" color={props.value} />
      <span>{props.value}</span>
    </HStack>
  )),
);
